import { render, staticRenderFns } from "./medicareReadCard.vue?vue&type=template&id=002ecd7b"
import script from "./medicareReadCard.vue?vue&type=script&lang=js"
export * from "./medicareReadCard.vue?vue&type=script&lang=js"
import style0 from "./medicareReadCard.vue?vue&type=style&index=0&id=002ecd7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports